export default async (context) => {
    if(context.text.length > 0) {

        let arr = context.preview[0]

        arr.index = context.preview[0].index - 1

        await context.$store.dispatch('main_videos/replaceVideo', {
            item: arr
        })

        await context.$store.dispatch('edit/clearEditableItem')

        context.$router.push('/video-editor')
    }
}